import Image from '@segment/matcha/components/Image'

import * as VideoPlayer from '@segment/matcha/components/VideoPlayer'

import coverPng2x from './assets/Cover@2x.png'
import coverWebp from './assets/Cover.webp'
import coverWebp2x from './assets/Cover@2x.webp'

const CoverImage = () => {
  return (
    <VideoPlayer.Cover>
      <picture>
        <source type="image/webp" srcSet={`${coverWebp}, ${coverWebp2x} 2x`} />
        <Image width={832} height={473} src={coverPng2x} alt="" />
      </picture>
    </VideoPlayer.Cover>
  )
}

export default CoverImage
